import { DarkModeOutlined, LightModeOutlined } from '@mui/icons-material';
import { useModeTheme } from 'contexts/ModeThemeContext';
import React from 'react';
import IconSwitch from './IconSwitch';

const ThemeModeButton: React.FC = () => {
	const { dark, setDark } = useModeTheme();

	return (
		<IconSwitch
			checked={dark}
			onChange={setDark}
			data-testid="theme-mode-button"
			checkedIcon={<DarkModeOutlined />}
			uncheckedIcon={<LightModeOutlined />}
		/>
	);
};

export default ThemeModeButton;
